import React, { useState, useEffect, useCallback } from 'react';
import Navbar from '../../components/Navbar';
import { adminAPI } from '../../services/api';

/**
 * Admin refund approval queue. A paid order that gets cancelled (any path) now marks its
 * refund 'awaiting_approval' instead of auto-refunding. Here an admin reviews and Approves
 * (→ issues the Cashfree refund) or Denies it.
 */
function Refunds() {
  const [orders, setOrders] = useState([]);
  const [loading, setLoading] = useState(true);
  const [busy, setBusy] = useState(null); // orderId being acted on
  const [msg, setMsg] = useState('');

  const load = useCallback(async () => {
    setLoading(true);
    try {
      const r = await adminAPI.getPendingRefunds();
      setOrders(r.data?.data || []);
    } catch (e) { setMsg('Failed to load refunds'); }
    finally { setLoading(false); }
  }, []);
  useEffect(() => { load(); }, [load]);

  const approve = async (o) => {
    if (!window.confirm(`Approve & issue refund of ₹${o.refund?.amount} for ${o.orderNumber}? This sends the money back via Cashfree.`)) return;
    setBusy(o._id); setMsg('');
    try {
      await adminAPI.approveRefund(o._id);
      setMsg(`Refund issued for ${o.orderNumber}`);
      await load();
    } catch (e) { setMsg(e.response?.data?.message || 'Approve failed'); }
    finally { setBusy(null); }
  };

  const deny = async (o) => {
    const reason = window.prompt(`Deny the refund for ${o.orderNumber}? Optional reason:`, '');
    if (reason === null) return; // cancelled the prompt
    setBusy(o._id); setMsg('');
    try {
      await adminAPI.denyRefund(o._id, reason || 'Denied by admin');
      setMsg(`Refund denied for ${o.orderNumber}`);
      await load();
    } catch (e) { setMsg(e.response?.data?.message || 'Deny failed'); }
    finally { setBusy(null); }
  };

  const card = { background: '#fff', border: '1px solid #eee', borderRadius: 12, padding: 16, marginBottom: 12, boxShadow: '0 2px 6px rgba(0,0,0,0.05)' };
  const btn = (bg) => ({ padding: '8px 16px', background: bg, color: '#fff', border: 'none', borderRadius: 8, fontWeight: 700, cursor: 'pointer' });

  return (
    <div style={{ minHeight: '100vh', background: '#f4f6f8' }}>
      <Navbar />
      <div style={{ maxWidth: 900, margin: '0 auto', padding: 24 }}>
        <h1 style={{ fontSize: 24, fontWeight: 800, color: '#0F172A', margin: '0 0 4px' }}>💸 Refund Approvals</h1>
        <p style={{ color: '#64748B', fontSize: 14, margin: '0 0 16px' }}>
          Paid orders that were cancelled are held here until you approve the refund. Approving issues the Cashfree refund; denying declines it.
        </p>
        {msg && <div style={{ ...card, borderColor: '#10B981', color: '#059669' }}>{msg}</div>}
        {loading ? <div style={{ padding: 16 }}>Loading…</div> : orders.length === 0 ? (
          <div style={{ ...card, color: '#94a3b8' }}>No refunds awaiting approval. 🎉</div>
        ) : orders.map((o) => (
          <div key={o._id} style={card}>
            <div style={{ display: 'flex', justifyContent: 'space-between', flexWrap: 'wrap', gap: 10, alignItems: 'center' }}>
              <div>
                <div style={{ fontWeight: 800, fontSize: 16 }}>#{o.orderNumber} · ₹{o.refund?.amount} <span style={{ fontSize: 12, fontWeight: 600, color: '#7C3AED' }}>({o.orderType === 'delivery_service' ? 'Delivery Service' : 'Food'} · {o.paymentMethod?.toUpperCase()})</span></div>
                <div style={{ fontSize: 13, color: '#64748B', marginTop: 4 }}>
                  {o.restaurantId?.name || '—'} · customer {o.userId?.name || '—'} {o.userId?.phone || ''}
                </div>
                <div style={{ fontSize: 12, color: '#94a3b8', marginTop: 2 }}>
                  Cancelled by <b>{o.cancelledBy || '—'}</b> · {o.cancellationReason || o.refund?.reason || '—'} · requested {o.refund?.requestedAt ? new Date(o.refund.requestedAt).toLocaleString('en-IN') : '—'}
                </div>
              </div>
              <div style={{ display: 'flex', gap: 8 }}>
                <button onClick={() => approve(o)} disabled={busy === o._id} style={btn('#16a34a')}>{busy === o._id ? '…' : 'Approve & refund'}</button>
                <button onClick={() => deny(o)} disabled={busy === o._id} style={btn('#dc2626')}>Deny</button>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

export default Refunds;
